export const APP_NAVIGATION = {
  NONE: "NONE", // None
  HOME: "HOME", // Home
  TEMP: "TEMP", // Template
  STEM: "STEM", // State Template
  SINI: "SINI", // Sign in
  SINU: "SINU", // Sing up
  SIOT: "SIOT", // Sing Out
  PLAN: "PLAN", // Plan page
  CONF: "CONF", // Confirmation
  CHPG: "CHPG", // Checkout Page
  ABTPG: "ABTPG", //about page
  CONPG: "CONPG", //Contact page
  TERMS: "TERMS", //Terms n Condition
  PRVCY: "PRVCY", //privacy n policy
  LANDING: "LANDING", //landing page
};

export const ROUTE_CONSTANT = {
  HOME: "/app/template",
  SSO_TRANSFER: "/app/template/sso-transfer",
  USER_DASHBOARD: "/app/dashboard",
  SIGNIN: "/app/template/sign-in",
  SIGNUP: "/app/template/sign-up",
  PAYMENT_PLAN: "/app/billing/plans",
  CHECKOUT_PAGE: "/app/template/checkout",
  PAYMENT_CONFIRMATION: "/app/template/confirmation",
  THANK_YOU: "/app/thank-you",
  FORGET_PASSWORD: "/app/template/forget-password",
  ABOUT: "/about",
  CONTACT: "/contact/",
  TERMSNCOND: "/terms/",
  PRIVACY: "/privacy/",
  WS_CONTACT: "/support/contact/",
  WS_TERMSNCOND: "/terms-and-conditions/",
  WS_PRIVACY: "/privacy-policy/",
  LANDINGPAGE: "/",
};

export const DomainName = {
  PDFSIMPLI: "pdfsimpli",
  RESUMEBUILD: "resumebuild",
  LEGALSIMPLI: "legalsimpli",
  SIGNSIMPLI: "signsimpli",
  WORKSIMPLI: "worksimpli",
};
export const BasePortalCD = {
  PS: "PS",
  WSRB: "WSRB",
  SS: "SS",
  LSEN: "LSEN",
  WKSM: "WKSM",
};

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const invalidMailboxStatuses = ["mailbox_not_found", "no_mailbox"];
